module.exports = __webpack_public_path__ + "assets/fonts/arrow-right-1.d32b4f89.svg";